export default __webpack_public_path__ + "static/pic2-7b3e54d07cd03dc4296379db93f8c7c7.jpg";